<template>
  <v-card flat>
    <v-card-title class="subheader py-0" style="height: 48px">
      <v-icon small class="mr-1" color="blue">chat</v-icon>
      支出明细
      <v-spacer/>
      <span v-if="balance" class="pl-4 pt-1"
         style="font-weight: 400;font-size: 13px; margin-bottom: 0" >
        经费余额: {{Number(balance.xmje) | currency}} 元
      </span>
    </v-card-title>

    <v-divider color="blue" />

    <v-card-text class="pt-0">
      <v-data-table
        :headers="headers"
        :items="items"
        class="elevation-0 dense"
        no-data-text="没有数据。"
        :rows-per-page-items="[10]">
      >
        <template slot="items" slot-scope="props">
          <td>{{props.index + 1 }}</td>
          <td>{{ props.item.jje | currency}}</td>
          <td>{{ props.item.zy }}</td>
          <td>{{ props.item.pzrq }}</td>
          <!--
          <td class="justify-center layout px-0">
            <v-tooltip top>
              <v-btn icon class="mx-0" slot="activator"
                     @click="
                         () => {
                            viewDbid = props.item.dbid; view = true;
                         }">
                <v-icon color="teal">more_horiz</v-icon>
              </v-btn>
              <span>查看</span>
            </v-tooltip>
          </td>
          -->
        </template>
      </v-data-table>
    </v-card-text>

    <x-view
      v-model="view"
      :dbid="viewDbid"
    />


  </v-card>
</template>
<script>
  import {mapGetters} from 'vuex'

  import XView from './View'

  const baseURI = '/api/cw/zcmx';
  const balanceURI = '/api/proj/fund/balance';


  export default {
    components: {XView},

    props: {
      project: Object
    },

    data: () => ({
      uri: baseURI,
      headers: [
        {
          text: '#',
          sortable: false,
          value: 'dbid',
          width: '20'
        },
        {text: '金额', value: 'jje', sortable: false, width: 120},
        {text: '备注', value: 'zy', sortable: false},
        {text: '凭证日期', value: 'pzrq', sortable: false,}
        // {text: '操作', value: 'pznm', sortable: false, align: 'center', width: 60}

      ],

      items: [],

      balance: null,

      view: false,
      viewDbid: null,

      edit: false,
      editDbid: null,
      projectId: null,

      dele: false,
      deleDbid: null,
      deleMsg: null,

    }),

    computed: {
      ...mapGetters(['funcIds'])
    },

    watch: {
      project(p) {
        this.axios.all([
          this.axios.get(`${baseURI}?projectId=${p.dbid}`),
          this.axios.get(`${balanceURI}/${p.dbid}`)
        ]).then(this.axios.spread(
          (rspZcmx, rspBala) => {
            this.items = rspZcmx.data.items;
            this.balance = rspBala.data;
          }))
      }
    },

    methods: {
    }
  }
</script>
